import React from 'react';
import {
  tags,
} from "./response.module.css"

const NormalResponse = (props) => (
  <>
    <h2>{props.correctAnswer}</h2> is <em>Correct!</em>
    <br />
    {props.response}
    <ul className={tags}> {props.questionSet.questions[props.currentQuestion].tags.map((tag) => <li>{tag.toUpperCase()}</li>)}</ul>
  </>
)

export default NormalResponse